import { useCotizacionStore } from '../Providers/CotizacionStore';
import { esLandingDeVendedor } from './rutaVendedor';

/** Textos del cotizador común de Auto que cambian para el asesor de venta presencial (US 23866). */
export interface TextosCotizadorAuto {
  tituloCotizador: string;
  patente: string;
  tituloDatos: string;
  /** Nombre del grupo de datos personales. El cliente lo ve como subtítulo ("Sobre vos"); para el asesor
   *  queda solo para lectores de pantalla, porque le hablaría a él. */
  leyendaPersona: string;
  leyendaPersonaVisible: boolean;
  /** Leyendas de los bloques de contacto y de ubicación de la pantalla de datos. */
  leyendaContacto: string;
  leyendaUbicacion: string;
}

const TEXTOS_CLIENTE: TextosCotizadorAuto = {
  tituloCotizador: 'Cotizá tu auto online y encontrá el mejor precio',
  patente: 'Ingresá tu patente',
  tituloDatos: 'Completá tus datos',
  leyendaPersona: 'Sobre vos',
  leyendaPersonaVisible: true,
  leyendaContacto: 'Para mandarte los precios',
  leyendaUbicacion: 'Dónde circulás',
};

const TEXTOS_ASESOR: TextosCotizadorAuto = {
  tituloCotizador: 'Cotizá seguro de auto y encontrá el mejor precio',
  patente: 'Ingresá la patente',
  tituloDatos: 'Completá los datos',
  leyendaPersona: 'Datos del cliente',
  leyendaPersonaVisible: false,
  leyendaContacto: 'Datos de contacto del cliente',
  leyendaUbicacion: 'Dónde circula el auto',
};

export const textosCotizadorAuto = (esAsesor: boolean): TextosCotizadorAuto =>
  esAsesor ? TEXTOS_ASESOR : TEXTOS_CLIENTE;

/**
 * Los textos según quién cotiza. Asesor = cotización de Auto que arrancó en /auto/vendedor: la misma
 * regla que usan el registro del lead y el botón "Nueva cotización" de gracias. El cliente, y siempre
 * Moto (comparte la pantalla de datos), ven los de siempre.
 */
export const useTextosCotizadorAuto = (rubro: string): TextosCotizadorAuto => {
  const desdeVendedor = useCotizacionStore((s) => esLandingDeVendedor(s.cotizacionValues.landingUrl));
  return textosCotizadorAuto(rubro === 'auto' && desdeVendedor);
};
